import React from 'react';
import { Badge } from '../../../components/ui/badge';

interface ChatListItemProps {
    contactName: string;
    platform: string;
    status: 'nuevo' | 'respondido' | 'archivado';
    isSelected?: boolean;
    onClick?: () => void;
}

const ChatListItem: React.FC<ChatListItemProps> = ({
    contactName,
    platform,
    status,
    isSelected = false,
    onClick
}) => {
    const getStatusColor = () => {
        switch (status) {
            case 'nuevo':
                return 'bg-blue-500 text-white';
            case 'respondido':
                return 'bg-gray-500 text-white';
            case 'archivado':
                return 'bg-gray-300 text-gray-700';
            default:
                return 'bg-blue-500 text-white';
        }
    };

    return (
        <div
            className={`p-4 border-b border-gray-200 cursor-pointer hover:bg-gray-50 transition-colors ${isSelected ? 'bg-blue-50 border-l-4 border-l-blue-500' : ''}`}
            onClick={onClick}
        >
            <div className="flex justify-between items-start mb-2">
                <h3 className="font-medium text-gray-900">{contactName}</h3>
                <Badge className={`text-xs px-2 py-1 rounded-full ${getStatusColor()}`}>
                    {status}
                </Badge>
            </div>
            <p className="text-sm text-gray-600">{platform}</p>
        </div>
    );
};

export default ChatListItem;
